import React, { Fragment } from "react";
import { ToastContainer } from "react-toastify";
import { useParams, useLocation} from 'react-router-dom';
import 'ace-builds/src-noconflict/ace';
import 'ace-builds/src-noconflict/ext-language_tools';
import 'ace-builds/src-noconflict/mode-json';
import 'ace-builds/src-noconflict/theme-tomorrow';
import AceEditor from "react-ace";
import useForm from '../../hooks/useForm';
import { useService } from "../../hooks/useService";
import Loading from "../../components/common/loading";
import useGoogleSearch from "../../hooks/useSearch.js";
import Input from '../../components/common/form/input';
import Select from "../../components/common/form/select";
import Breadcrumb from "../../components/common/breadcrumb";
import TextArea from '../../components/common/form/textarea';
import { Alert } from "../../components/common/modals/modals";
import { Switch } from '../../components/common/switch/switch.js';
import ImageSearchGallery from "../../components/image-search/image-search-gallery.js";

const ProductForm = ({history}) => {

    const params = useParams();
    const service = useService();
    const location = useLocation();
    const [loading, setLoading] = React.useState(true);
    const [isNewRegister, setIsNewRegister] = React.useState(false);
    
    // PARAMETERS
    const name = useForm('name');
    const EAN = useForm('EAN');
    const isActive = useForm('isActive');
    const registerDate = useForm('date');
    const description = useForm('description');
    const weight = useForm(false);
    const height = useForm(false);
    const width = useForm(false);
    const depth = useForm(false);
    const updatedByUsername = useForm(false);
    const manufacturer = useForm(false);
    const segment = useForm(false);
    const subSegment = useForm(false);
    const region = useForm(false);
    const idealPrice = useForm(false);
    const priceOutlierFactor = useForm(false);
    const priceRangeFactor = useForm(false);
    const aiFilterKeywords = useForm(false);
    const aiSearchKeywords = useForm(false);
    const brand = useForm('brand', -1);
    const [googleSearchQuery, setGoogleSearchQuery] = React.useState('');
    const [brandOptions, setBrandOptions] = React.useState([]);
    const productCategory = useForm('category', -1);
    const [productCategoriesOptions, setProductCategoriesOptions] = React.useState([]);

    const { googleSearchResults } = useGoogleSearch(googleSearchQuery);

    const handleSubmit = async event => {
        event.preventDefault();
        name.validate();
        
        if (name.validate()) {
            isNewRegister? create() : update()
        }
    };

    const getProduct = async (id) => {
        await service.get(`/api/product/details/${id}`)
            .then(response => {
                const result = response?.data?.data;                

                if(result) {
                    name.setValue(result.name);
                    EAN.setValue(result.ean);
                    isActive.setValue(result.isActive);
                    let rd = new Date(result.registerDate);
                    registerDate.setValue(`${rd.getFullYear()}-${(rd.getMonth()+1).toString().padStart(2, '0')}-${rd.getDate().toString().padStart(2, '0')}`);
                    description.setValue(result.description);
                    weight.setValue(result.weight);
                    height.setValue(result.height);
                    width.setValue(result.width);
                    depth.setValue(result.depth);
                    updatedByUsername.setValue(result.updatedByUsername);
                    manufacturer.setValue(result.manufacturer);
                    segment.setValue(result.segment);
                    subSegment.setValue(result.subSegment);
                    region.setValue(result.region);
                    idealPrice.setValue(result.idealPrice);
                    priceOutlierFactor.setValue(result.priceOutlierFactor);
                    priceRangeFactor.setValue(result.priceRangeFactor);
                    aiFilterKeywords.setValue(result.aiFilterKeywords);

                    if(result.aiSearchKeywordsJSON) {
                        const formattedJsonString = result.aiSearchKeywordsJSON
                        .replace(/\\r\\n/g, '\r\n')
                        .replace(/\\n/g, '\n')
                        .replace(/\\t/g, '\t')
                        .replace(/\\"/g, '"');
                        const jsonObject = JSON.parse(formattedJsonString);
                        aiSearchKeywords.setValue(JSON.stringify(jsonObject, null, 2));
                    }

                    brand.setValue(result.brandId);
                    productCategory.setValue(result.categoryId);
                    priceRangeFactor.setValue(result.priceRangeFactor);
                    priceRangeFactor.setValue(result.priceRangeFactor);
                    setGoogleSearchQuery(`${result.manufacturer} ${result.name} ${result.category} ${result.brand}`);
                }else {
                    console.log('ERROR')
                    history.replace('/product/list')
                }
                
                setLoading(false);
            })
            .catch(e => {
                console.log('ERROR: ', e)
                history.replace('/product/list')
            })
    }

    const getBrands = async () => {
        await service.get("/api/brand/list")
            .then(async response => {
                const result = response?.data?.data;
                setBrandOptions(result.map(r => ({
                    label: r.name,
                    name: r.name,
                    value: r.id,
                    id: r.id
                })))
            });
    }

    const getProductCategories = async () => {
        await service.get(`/api/ProductCategory/list`)
            .then(response => {
                const result = response?.data?.data;
                if (result) {
                    setProductCategoriesOptions(result.map(r => ({
                        label: r.name,
                        name: r.name,
                        value: r.id,
                        id: r.id
                    })))
                }
            });
    }

    const getPayload = () => {
        var aiSearchKeywordsValue = null;
        if(aiSearchKeywords.value !== null && aiSearchKeywords.value !== "" && aiSearchKeywords.value !== undefined) {
            const jsonObject = JSON.parse(aiSearchKeywords.value);
            aiSearchKeywordsValue = JSON.stringify(jsonObject);
        }

        return ({
            id: params.id,
            name: name.value,
            isActive: isActive.value,
            EAN: EAN.value,
            segment: segment.value,
            subSegment: subSegment.value,
            brandId: brand.value,
            categoryId: productCategory.value,
            manufacturer: manufacturer.value,
            idealPrice: idealPrice.value,
            weight: weight.value,
            priceOutlierFactor: priceOutlierFactor.value,
            priceRangeFactor: priceRangeFactor.value,
            aiSearchKeywordsJSON: aiSearchKeywordsValue,
            aiFilterKeywords: aiFilterKeywords.value
        });
    };    

    const create = async () => {}

    const update = async () => {
        if(aiSearchKeywords.value !== null && aiSearchKeywords.value !== "" && aiSearchKeywords.value !== undefined) {
            try { 
                const jsonObject = JSON.parse(aiSearchKeywords.value);
                JSON.stringify(jsonObject);
            } catch (error) { 
                Alert("Campo 'Filtro IA - SearchKeywords' incorreto", "", "error");
                console.error('Failed to parse JSON string:', error.message);
                return;
            }
        }

        var payload = getPayload();
        payload.id = params.id;
  
        await service.put(`/api/product/edit`, payload)
            .then(response => {
                const success = response?.data?.status === 200;
  
                if(success){
                  Alert("Produto atualizado com sucesso!", "", "success");
                }else{
                  Alert(response.data.title ? response.data.title : "Não foi possível atualizar o produto", "", "error");
                }
            })
    }

    const onChangeJsonEditor = (newValue) => {
        aiSearchKeywords.setValue(newValue);
    }

    React.useEffect(() => {
        async function init() {
        
            const create = location.pathname.indexOf("new") !== -1;
            let id = create ? undefined : params.id;
            getBrands();
            getProductCategories();

            if (id) {
                // const edit = location.pathname.indexOf("details") === -1;
                setIsNewRegister(false);
    
                getProduct(id); 
            } else {
                setLoading(false);
            }
        }
        init()
    }, []);

    return (
        <main className='form-container campaign-form'>
            <div className="ml-5p">
                <Breadcrumb title={isNewRegister ? "Cadastro" : "Edição"} parent="Produtos" marginLeft={true} />
            </div>

            <div className="container-fluid">
                <div className="row">
                    <div className="col-sm-12">
                        <div className="card form-card">
                            <div className="card-body">

                                {loading && <Loading/>}

                                { !loading && <Fragment>
                                    <h1 className='align-center pt-15'>{name.value}</h1>

                                    <ImageSearchGallery imageUrls={googleSearchResults} />

                                    <div className="card-body">
                                        <form className="needs-validation" noValidate="" onSubmit={handleSubmit}>
                                            <div className="grid-col2">
                                                <Input label='Nome' type='text' name='name' required={true} {...name} maxLength={50} inputClassName='w-20vw' />

                                                <div>
                                                    <br/>
                                                    <div className="flex" style={{alignItems: 'end'}}>
                                                        <Switch 
                                                            handleToggle={() => isActive.setValue(!isActive.value)}
                                                            isOn={isActive.value}
                                                            id="product-status-toggle"/>
                                                        <label style={{ fontSize: '14px'}}>
                                                            &nbsp;Produto {isActive.value ? 'Ativo' : 'Inativo'}
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="grid-col2">
                                                <Input label='EAN' type='text' name='EAN' required={true} {...EAN} maxLength={50} inputClassName='w-20vw' />
                                                
                                                <Select 
                                                    label='Categoria'
                                                    name='brand'
                                                    required={true}
                                                    {...productCategory}
                                                    options={productCategoriesOptions}
                                                    disabled={false}
                                                />
                                            </div>

                                            <div className="grid-col2">
                                                <Input label='Segmento' type='text' name='segment' required={false} {...segment} inputClassName='w-20vw' />
                                                <Input label='Subsegmento' type='text' name='subsegment' required={false} {...subSegment} inputClassName='w-20vw' />
                                            </div>

                                            <div className="grid-col2">
                                                <Select 
                                                    label='Marca'
                                                    name='brand'
                                                    required={false}
                                                    {...brand}
                                                    options={brandOptions}
                                                    disabled={false}
                                                />                                        
                                                <Input label='Fabricante' type='text' name='manufacturer' required={false} {...manufacturer} maxLength={50} inputClassName='w-20vw' />
                                            </div>

                                            <div className="grid-col2">
                                                <Input label='Preço ideal' type='number' name='idealPrice' required={false} {...idealPrice} inputClassName='w-20vw' />
                                                <Input label='Peso' type='number' name='weigth' required={false} {...weight} maxLength={50} inputClassName='w-20vw' />
                                            </div>

                                            <div className="grid-col2">
                                                <Input label='Outlier de Preço (Outlier Factor)' type='number' name='priceOutlierFactor' required={false} {...priceOutlierFactor} inputClassName='w-20vw' />
                                                <Input label='Variação de preço (Range Factor)' type='number' name='priceRangeFactor' required={false} {...priceRangeFactor} maxLength={50} inputClassName='w-20vw' />
                                            </div>

                                            <Input label='Filtro IA - Palavras Chaves' type='text' name='aiFilterKeywords' required={false} {...aiFilterKeywords} maxLength={50} inputClassName='w-50vw' />

                                            <Fragment>
                                                <label htmlFor="aiSearchKeywords">Filtro IA - SearchKeywords</label>
                                                <AceEditor
                                                    className="w-50vw"
                                                    mode="json"
                                                    theme="tomorrow"
                                                    onChange={onChangeJsonEditor}
                                                    name="aiSearchKeywords"
                                                    tabSize={2}
                                                    enableBasicAutocompletion={true}
                                                    value={aiSearchKeywords.value}
                                                    editorProps={{ $blockScrolling: true }}
                                                />
                                                <br/>
                                            </Fragment>
                                            
                                            <TextArea label='Descrição' type='text' name='description' rows={4} maxLength={250} disabled={true} required={false} {...description} />

                                            <div className="grid-col2">
                                                <Input label='Altura' type='number' name='height' disabled={true} required={false} {...height} inputClassName='w-20vw' />
                                                <Input label='Largura' type='number' name='width' disabled={true} required={false} {...width} maxLength={50} inputClassName='w-20vw' />
                                            </div>

                                            <div className="grid-col2">
                                                <Input label='Profundidade' type='number' name='depth' disabled={true} required={false} {...depth} maxLength={50} inputClassName='w-20vw' />
                                                <Input label='Região' type='text' name='region' disabled={true} required={false} {...region} maxLength={50} inputClassName='w-20vw' />
                                            </div>
                                                
                                            <div className="grid-col2">
                                                <Input label='Data de cadastro' type='date' name='registerDate' disabled={true} required={false} {...registerDate} inputClassName='w-20vw' />
                                                {updatedByUsername.value !== null && <Input label='Atualizado por' type='text' name='updatedByUsername' disabled={true} required={false} {...updatedByUsername} maxLength={50} inputClassName='w-20vw' /> }
                                            </div>

                                            <div className='align-center'>
                                                <button className="btn btn-pill btn-outline-secondary" type="submit">Atualizar</button>
                                            </div>

                                        </form>
                                    </div>
                                </Fragment> }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
        </main>
    );
};

export default ProductForm;